export class CollectionData {
    constructor() {
        this.layers = [];
        this.mask = [];
    }

    /**
     * All added layers must be the same size.
     *
     * @param {Object} layer
     */
    addLayer(layer) {
        // Init mask to 0.
        if (this.mask.length <= 0) {
            this.mask = Array(layer.data.length).fill(0);
        }

        for (let i = 0; i < layer.data.length; i++) {
            if (layer.data[i] > 0) this.mask[i] = 1;
        }

        this.layers.push(layer);
    }


    getAll(){
        //list of collectibles to spawn
        let data = [];

        for (let i = this.mask.length - 1; i >= 0; i--) {
            if (this.mask[i] > 0) {
                data.push(i);
            }
        }
        return data;
    }

}
